import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_2 = { class: "divide-y divide-gray-200" }

import { useOrders } from "@/composables/orders";
import { computed, Prop, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  columns: Array as PropType<string[]>,
  rows: Array as PropType<any[]>,

  getKey: Function as PropType<(row: any) => string>,
},
  setup(__props) {

const props = __props



const rowKey = (row: any) => {
  if (props.getKey) return props.getKey(row);
  return row?.id;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
          return (_openBlock(), _createElementBlock("th", {
            key: col,
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
          }, [
            _renderSlot(_ctx.$slots, 'th-' + col, _normalizeProps(_guardReactiveProps({
              column: col,
            })))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: rowKey(row)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col, colIndex) => {
            return (_openBlock(), _createElementBlock("td", {
              key: col,
              class: _normalizeClass(["py-4 text-sm", [
            colIndex === 0
              ? 'py-3.5 pl-4 pr-3 sm:pl-6 md:pl-0'
              : colIndex < __props.columns.length
              ? 'py-3.5 px-3 '
              : 'py-3.5 pl-3 pr-4 sm:pr-6 md:pr-0',
          ]])
            }, [
              _renderSlot(_ctx.$slots, 'td-' + col, _normalizeProps(_guardReactiveProps({
              column: col,
              row,
              rowIndex,
              colIndex,
            })))
            ], 2))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})